import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { INSURANCE_TYPE } from 'common/constants';
import { PERMISSION_LIST } from 'common/constants/permissions';
import { getFinancierType } from 'common/utils/session';

export default () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const financierType = getFinancierType();

    const permission = [
        PERMISSION_LIST.INSURANCE_DOCUMENTS_PERMISSION,
        PERMISSION_LIST.ALLIANCE_DOCUMENTS_PERMISSION,
        PERMISSION_LIST.APPLICATION_DOCUMENTS_PERMISSION,
    ];

    const options = [
        {
            label: t('Document files'),
            permission: permission,
            selected: ['/configuration/documents'].includes(pathname),
            to: '/configuration/documents',
        },
        {
            label: t('Coverage'),
            visible: financierType !== INSURANCE_TYPE,
            permission: permission,
            selected: ['/configuration/insurances'].includes(pathname),
            to: '/configuration/insurances',
        },
    ];

    return options;
};
